<template>
	<div class="value-field--inline">
		<span class="light-mono" :class="{ editable }">{{ displayValue }}</span>
	</div>
</template>

<style lang="scss" scoped>
.value-field--inline {
	margin-right: 15px;
}

.editable {
	color: var(--v-primary-darken1);
}
</style>

<script>
import base from "./base";

export default {
	extends: base,

	computed: {
		editable() {
			return this.meta.editable || false;
		},
	},
};
</script>
